import React, { useEffect } from 'react'
import Item from '../../../components/item/Item';
import { useDispatch, useSelector } from 'react-redux';
import { getFilteredItems, selectItems, selectPage, selectItemPerPage, selectSubCategories } from '../../../slice/itemSlice'
import { Row, Spinner } from 'react-bootstrap';

const Items = () => {

  const dispatch = useDispatch();
  const items = useSelector(selectItems);
  const page = useSelector(selectPage);
  const iPP = useSelector(selectItemPerPage);
  const subCategories = useSelector(selectSubCategories);


  useEffect(() => {
    dispatch(getFilteredItems())
  }, [subCategories, dispatch])

  return (<>
    <Row className='mt-0'>
      {items.length === 0 && <Spinner animation="border" variant="info" />}
      {items.slice((page-1)*iPP, page*iPP).map(d => <Item key={d.id} subCategory={d.subCategory} name={d.name} tag={d.tag} image={d.image} price={d.price} id={d.id}/>)}
    </Row>
  </>)
}

export default Items